// extracted by mini-css-extract-plugin
export default {"container_cartbutton":"style_container_cartbutton__+Anjl","shopping_cart":"style_shopping_cart__X8t0D","amount":"style_amount__D0D7u"};